import React from 'react';

import HotelIcon from '@mui/icons-material/Hotel';
import { Alert, Box, Grid, Stack, Typography } from '@mui/material';

import { definitions } from '@luxuryescapes/contract-svc-promo';

import BorderedGridItem from '~/components/Common/BorderedGridItem';
import PromoItemField from '~/components/PromoV3/PromoItemField';

import { getPromoProductDisplayName, sortPromoItemByCategoryAndId } from '~/services/PromoService';

import currencyFormatter from '~/utils/currencyFormatter';
import { getCurrencyCodeByRegionCode } from '~/utils/getCurrencyCodeByRegionCode';

type PromoOrderTableCellProps = {
  order: definitions['Discount Request']['order'] | null;
  meta: definitions['PromoMeta'];
};

function PromoOrderTableCell({ order, meta }: PromoOrderTableCellProps) {
  if (order == null || order.region == null) {
    return null;
  }

  const currencyCode = getCurrencyCodeByRegionCode(order?.region);

  return (
    <Box sx={{ width: '100%' }} title={JSON.stringify(order, null, 4)}>
      {order.items.sort(sortPromoItemByCategoryAndId).map((item, i) => {
        if (!currencyCode) {
          return (
            <Alert severity="warning" title={`Currency code not found for region ${order.region}`}>
              Currency code not found for region {order.region}
            </Alert>
          );
        }
        return (
          <Grid container key={`${item.offerId}_${i}`} spacing={1} title={`${JSON.stringify(item, null, 4)}`}>
            <BorderedGridItem noBorder={i === order.items.length - 1}>
              <Stack>
                {currencyFormatter(currencyCode, item.luxPlusPrice || item.discountableTotal)}
                {item.luxPlusPrice && item.luxPlusPrice > 0 && (
                  <Typography
                    sx={{
                      textTransform: 'uppercase',
                      display: 'inline',
                      fontSize: 14,
                      fontWeight: 300,
                      textDecoration: 'line-through',
                      marginLeft: 1,
                    }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    {currencyFormatter(currencyCode, item.discountableTotal)}
                  </Typography>
                )}
                <Stack spacing={0.25}>
                  <PromoItemField
                    title="Product Type"
                    field="productType"
                    categoryBK={item.categoryBK}
                    value={
                      meta && getPromoProductDisplayName(meta.promo_product_types, item.categoryBK, item.subCategoryBK)
                    }
                  />
                  <PromoItemField
                    title="Loyalty Offer Type"
                    field="loyaltyOfferType"
                    categoryBK={item.categoryBK}
                    value={item.loyaltyOfferType}
                  />
                </Stack>
                {order.hasBedbankPromotion && (
                  <Box title="Has Bedbank Promotion">
                    <HotelIcon />
                  </Box>
                )}
              </Stack>
            </BorderedGridItem>
          </Grid>
        );
      })}
    </Box>
  );
}

export { PromoOrderTableCell };
